<h1 mat-dialog-title>Befund erstellen</h1>

<div mat-dialog-content>
    <!--    <mat-form-field style="width: 100%">-->
    <!--        <mat-label>Befundkategorie</mat-label>-->
    <!--        <mat-select [(ngModel)]="pbs.kategorie" name="kategorieSelect">-->
    <!--            <mat-option *ngFor="let k of kategorien; let i = index" [value]="k">-->
    <!--                {{ k }}-->
    <!--            </mat-option>-->
    <!--        </mat-select>-->
    <!--    </mat-form-field>-->

    <h4>Anzahl Proben festlegen</h4>
    <table class="phito-table">
        <thead>
            <tr>
                <th style="padding: 0 6px">Nr.</th>
                <th style="padding: 0 6px">Tieranzahl</th>
                <th style="padding: 0 6px">Tierart</th>
                <th style="padding: 0 6px">Tiergewicht</th>
                <th style="padding: 0 6px">Untersuchungsmaterial</th>
                <th style="padding: 0 6px">Kennzeichnung</th>
                <th style="padding: 0 6px">Probenanzahl</th>
                <th style="padding: 0 6px">Kategorie-Auswahl</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let p of pbs.materialien; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ p?.anzahl }}</td>
                <td>{{ p?.tierart }}</td>
                <td>{{ p?.gewicht }} kg</td>
                <td>{{ p?.untersuchungsmaterial }}</td>
                <td>{{ p?.kennzeichnung }}</td>
                <td>
                    <mat-form-field style="width: 100%">
                        <input matInput type="number" min="1" [(ngModel)]="p.anzahl_proben" />
                    </mat-form-field>
                </td>
                <td>
                    <mat-form-field style="min-width: 20%">
                        <mat-label>Befundkategorie</mat-label>
                        <mat-select [(ngModel)]="p.kategorie">
                            <mat-option *ngFor="let k of kategorien" [value]="k">
                                {{ k }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<mat-dialog-actions align="end">
    <button mat-button color="primary" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isDisabled()"> Speichern</button>
</mat-dialog-actions>
